export const GET_PARTICIPANT_SUGGESTIONS = 'GET_PARTICIPANT_SUGGESTIONS'
export const GET_PARTICIPANT_SUGGESTIONS_SUCCESS = 'GET_PARTICIPANT_SUGGESTIONS_SUCCESS'
export const GET_PARTICIPANT_SUGGESTIONS_ERROR = 'GET_PARTICIPANT_SUGGESTIONS_ERROR'
